export default [
  { value: "", label: "Selecionar" },
  { value: "variable_percentual", label: "Percentual Variável" },
  { value: "fixed_percentage", label: "Percentual Fixo" },
  { value: "variable_value", label: "Valor Variável" },
  { value: "fixed_value", label: "Valor Fixo" }
];



// WEBPACK FOOTER //
// ./src/core/enum/discount-type-options.enum.js